import jQuery from 'jquery';
import {MediaQuery, Triggers,  Equalizer, DropdownMenu, OffCanvas, Toggler, Drilldown, Magellan} from 'foundation-sites';
import {ScrollSpy} from 'materialize-css';
import FontFaceObserver from 'fontfaceobserver';
import 'magnific-popup';
import 'stellar.js';
import WOW from 'wow.js';

import './libs/TweenMax.js';
import './libs/jquery.superscrollorama.js';


($ => {
  /**
   * Window load event listener
   */
  $(window).on('load', () => {

		initZF();

    $('.js-loading__inner').fadeOut('slow', function() {
      var timer = setInterval(function() {

        $('.js-loading').fadeOut(300, function() {
          clearInterval(timer);
          $(window).resize();
          $(window).scroll();
        });

      }, 100);
    });
  });

   initComponents();

   /**
    * Initialized frontend components.
    */
  function initComponents() {
    initHeader();
    initFontObserver();
    initMagnificPopup();
    initCover();
    initCover();
    initSuperScrollorama();
    initParallax();
    animate();
    credits();
  }

  /**
   * Initialize Foundation sites.
   */
  function initZF() {
    if($().foundation) {
      $(document).foundation();

      if(Magellan) {
        var mainMenuMagellan = new Magellan($('.js-magellan'), {
          threshold: 0,
          offset: -1
        });

        $('[data-magellan-target]').scrollSpy({
          throttle: 0,
          scrollOffset: -1
        });
      }

        /*
      if(OffCanvas && Drilldown) {
        var $hamburger = $('#hamburger');
        var $offCanvas = $('#off-canvas-menu');

        $('[data-drilldown] a[href^="#"]').click(() => {
          var interval = setInterval(() => {
            $offCanvas.foundation('close', () => {});
              $hamburger.removeClass('is-active');

            clearInterval(interval);
          }, 1300);
        });
      }
      */
    }
  }

  /**
   * Header stickines.
   */
  function initHeader() {
    var $header = $('#container > header');
    var isHeaderSticky = false;
    var headerHeight = getHeaderHeight();
    var headerTopPos = $header.offset().top;
    var topPos = $(window).scrollTop(); // Get the current scroll top position.

    toggleDarkMode();


    /**
     * Window's scroll listener.
     */
    $(window).scroll(() => {
      // Update scroll position.
      topPos = $(window).scrollTop();

      toggleHeaderStickiness();
      toggleDarkMode();
    });


    /**
     * Toogle header stickiness.
     */
    function toggleHeaderStickiness() {
      if(topPos > headerHeight && !isHeaderSticky) {
        $header.addClass('sticky');
        isHeaderSticky = true;
      }
      else if(topPos <= headerHeight && isHeaderSticky) {
        $header.removeClass('sticky');
        isHeaderSticky = false;
      }
    }


    /**
     * Toggle header dark mode.
     */
    function toggleDarkMode() {
        var $darkSections = $( '.js-section--dark' );

        $darkSections.each( function( i, e ) {
            var $section = $( e );
            var sectionTopPos = $section.offset().top;
            var sectionBottomPos = sectionTopPos + $section.innerHeight();
            
            if( topPos >= sectionTopPos && topPos <= sectionBottomPos ) {
                $header.addClass( 'dark' );
            } else {
                $header.removeClass( 'dark' );
            }
        } );
    }
  }


  /**
   * Fullscreen/fullheight cover.
   */
    function initCover() {
        var $cover = $( '.js-cover' );
        var coverHeight = $( window ).height() - ( getHeaderHeight() + getFooterHeight() );

        $cover.css( 'height', coverHeight + 'px' );
    }
    $( window ).on( 'resize', initCover );


  /**
   * Get the height header.
   *
   * @return {int} The header height in pixels.
   */
  function getHeaderHeight() {
    return $('#container > header').innerHeight();
  }


  /**
   * Get the height footer.
   *
   * @return {int} The foter height in pixels.
   */
  function getFooterHeight() {
    return $('#container > footer').innerHeight();
  }

  /**
   * Initialize font observer. Will detect if custom fonts are successfully loaded.
   */
  function initFontObserver() {
    if(FontFaceObserver) {
      var barlowFont = new FontFaceObserver('Barlow');
      var playfairDisplayFont = new FontFaceObserver('Playfair Display');

      $(document.body).addClass('font');

      barlowFont.load(null, 10000 /* 10 seconds */).then(() => {
        $(document.body).addClass('font--barlow');
      });

      playfairDisplayFont.load(null, 10000 /* 10 seconds */).then(() => {
        $(document.body).addClass('font--playfair-display');
      });
    }
  }


  /**
   * Magnific popup.
   */
  function initMagnificPopup() {
    if($().magnificPopup) {
        $('.js-inline').magnificPopup({
          type:'inline',
          midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
        });

      $('.js-video').magnificPopup({
        type: 'iframe',
        markup: '<div class="mfp-iframe-scaler">'+
          '<div class="mfp-close"></div>'+
          '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
        '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button 
        patterns: {
          youtube: {
              index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

              id: 'v=', // String that splits URL in a two parts, second part should be %id%
              // Or null - full URL will be returned
              // Or a function that should return %id%, for example:
              // id: function(url) { return 'parsed id'; }

              src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
            },
          vimeo: {
            index: 'vimeo.com/',
            id: '/',
            src: '//player.vimeo.com/video/%id%?autoplay=1'
          } 
        },
        gallery: {
          enabled: true
        },
        removalDelay: 300,
        mainClass: 'mfp-fade'
      });
    }
  }



    /**
     * Custom animation using SuperScrollorama & Greensock
     */
    function initSuperScrollorama() {
        if( $.superscrollorama && window.TweenMax ) {
            window.controller = $.superscrollorama( {
                playoutAnimations: false
            } );
            
            // Concept 1
            controller.addTween( '#concept-1',
                TweenMax.fromTo(
                    $( '#concept-1 figcaption' ),
                    1,
                    {
                        css: {
                            opacity: 1,
                            marginTop: 0
                        },
                        immediateRender: true,
                        useFrames: true

                    },
                    {
                        css: {
                            opacity: 0.0015,
                            marginTop: -150
                        }
                    }
                ),
                $( '#concept-1' ).innerHeight(),
                $( '#concept-1' ).innerHeight() / 2
            );

            // Concept 2
            controller.addTween( '#concept-2',
                TweenMax.fromTo(
                    $( '#concept-2 figcaption' ),
                    1,
                    {
                        css: {
                            opacity: 1,
                            marginTop: 0
                        },
                        immediateRender: true,
                        useFrames: true

                    },
                    {
                        css: {
                            opacity: 0.0015,
                            marginTop: -150
                        }
                    }
                ),
                $( '#concept-2' ).innerHeight(),
                $( '#concept-2' ).innerHeight() / 2
            );

            // First Edition
            controller.addTween( '#first-edition',
                TweenMax.fromTo(
                    $( '#first-edition figcaption' ),
                    1,
                    {
                        css: {
                            opacity: 1,
                            marginTop: 0
                        },
                        immediateRender: true,
                        useFrames: true

                    },
                    {
                        css: {
                            opacity: 0.0015,
                            marginTop: -150
                        }
                    }
                ),
                $( '#first-edition' ).innerHeight(),
                $( '#first-edition' ).innerHeight() / 2
            );
        }
    }


    /**
     * Stellar animation.
     */
    function initParallax() {
        if( $().stellar ) {
            $( window ).stellar( {
                horizontalScrolling: false,
                hideDistantElements: false
            } );
        }
    }



  /**
   * Animation using WOW.js
   */
  function animate() {
    // TODO: WOW setup.
    var wow = new WOW(
      {
        boxClass:     'wow',      // animated element css class (default is wow)
        animateClass: 'animated', // animation css class (default is animated)
        offset:       0,          // distance to the element when triggering the animation (default is 0)
        mobile:       true,       // trigger animations on mobile devices (default is true)
        live:         true,       // act on asynchronously loaded content (default is true)
        callback:     function(box) {
          // the callback is fired every time an animation is started
          // the argument that is passed in is the DOM node being animated
        },
        scrollContainer: null,    // optional scroll container selector, otherwise use window,
      }
    );
    wow.init();
  }



  /**
   * Determine of an element is in the viewport.
   *
   * @see https://www.javascripttutorial.net/dom/css/check-if-an-element-is-visible-in-the-viewport/ 
   * @param {HTMLElement} elem The HTML element.
   * @return {boolean}
   */
  function isInViewport(element) {
    if(element === null) return false;

    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  /**
   * Shorthand for console.log
   *
   * @param {string|object} message The message to log.
   */
  function log(message) {
    console.log(message);
  }

   /**
   * Log information to the console.
   */
  function credits() {
    const siteName = $(document.body).attr('data-site-name');
    const siteDescription = $(document.body).attr('data-site-description');
    const year = (new Date()).getFullYear();
    const copyright = `Copyright © ${year} ${siteName}. All rights reserved.`;
    const developer = 'Coded by: Den Isahac https://www.denisahac.xyz';
    
    console.log(`%c${siteName}`, 'font-family: Arial; font-size: 40px; font-weight: 700; color: rgb(91, 169, 218);');
    log(siteDescription);
    log(copyright);
    log('');
    log(developer);
  } 
})(jQuery);
